import { RichText } from 'basehub/react-rich-text'
import { clsx } from 'clsx'
import { ReactNode } from 'react'
import { PaymentSwitcher } from '~/app/(mkt)/pricing/fragments'

export const BillingSwitcher = ({
  selectedBilling,
  setSelectedBilling,
  ...props
}: {
  selectedBilling: 'monthly' | 'yearly'
  setSelectedBilling: (billing: 'monthly' | 'yearly') => void
} & (
  | PaymentSwitcher
  | { monthly: string; yearly: string }
  | {
      monthly: ReactNode
      yearly: ReactNode
    }
)) => {
  return (
    <div className="flex bg-dark-shade rounded-full text-xs tracking-tight p-1">
      <label
        className={clsx(
          'flex font-medium items-center gap-1 justify-center px-2.5 pt-px h-6 rounded-full text-dark-muted',
          selectedBilling === 'monthly'
            ? 'bg-dark-border-solid light:bg-dark-base !text-dark-bright'
            : 'opacity-70 hover:opacity-100'
        )}
      >
        <input
          className="hidden"
          type="radio"
          name="billing"
          value="monthly"
          checked={selectedBilling === 'monthly'}
          onChange={() => setSelectedBilling('monthly')}
        />
        {typeof props.monthly === 'string' ? (
          props.monthly
        ) : props.monthly &&
          typeof props.monthly === 'object' &&
          'switchLabel' in props.monthly ? (
          <RichText
            components={{
              em: ({ children }) => (
                <span className="text-dark-control-base text-[12px]">
                  {children}
                </span>
              ),
            }}
          >
            {props.monthly.switchLabel.json.content}
          </RichText>
        ) : (
          props.monthly
        )}
      </label>
      <label
        className={clsx(
          'flex font-medium items-center gap-1 justify-center px-2.5 pt-px h-6 rounded-full text-dark-muted',
          selectedBilling === 'yearly'
            ? 'bg-dark-border-solid !text-dark-bright light:bg-dark-base'
            : 'opacity-70 hover:opacity-100'
        )}
      >
        <input
          className="hidden"
          type="radio"
          name="billing"
          value="yearly"
          checked={selectedBilling === 'yearly'}
          onChange={() => setSelectedBilling('yearly')}
        />
        {typeof props.yearly === 'string' ? (
          props.yearly
        ) : props.yearly &&
          typeof props.yearly === 'object' &&
          'switchLabel' in props.yearly ? (
          <RichText
            components={{
              em: ({ children }) => (
                <span className="text-dark-control-base text-[11px] tracking-tight">
                  {children}
                </span>
              ),
            }}
          >
            {props.yearly.switchLabel.json.content}
          </RichText>
        ) : (
          props.yearly
        )}
      </label>
    </div>
  )
}
